import { FilterPillButton, FilterPillGroup } from '../components';

export type TodoFilterToggleProps = {
    checked: boolean;
    // Not-started items in the list, so the caption says how much is at stake.
    hiddenCount: number;
    onChange: (next: boolean) => void;
};

// Reveals the not-started items in a picker. Uses the app's filter-pill control
// (the report toolbar's tabs and Grid/List switch are the same component), in
// the compact size the dialog headers need.
export const TodoFilterToggle: React.FC<TodoFilterToggleProps> = ({ checked, hiddenCount, onChange }) => (
    <FilterPillGroup size="sm">
        <FilterPillButton active={checked} size="sm" onClick={() => onChange(!checked)}>
            View All{hiddenCount > 0 && ` (${hiddenCount})`}
        </FilterPillButton>
    </FilterPillGroup>
);
